import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Divider,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';

// Stat Card Component
const StatItem = ({ label, value, color }) => {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: '#f9f9f9',
          boxShadow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color }}>
          {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {value || 0}
        </Typography>
      </Box>
    </Grid>
  );
};

export default function PersonalTrainerStatsModal({
  totalTrainers,
  totalMembersCount,
  totalFees,
  open,
  setOpen,
}) {
  const handleDownload = () => {
    const stats = [
      ['Total Trainers', totalTrainers],
      ['Total Members', totalMembersCount],
      ['Total Income', totalFees],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([['Trainer Statistics', ''], ...stats]);
    worksheet['!cols'] = [{ width: 30 }, { width: 20 }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stats');
    XLSX.writeFile(workbook, 'personal_trainer_stats.xlsx');
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}>
        Trainer Statistics
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={3}>
          <StatItem label="Total Trainers" value={totalTrainers} color="#2E7D32" />
          <StatItem label="Total Members" value={totalMembersCount} color="#0288D1" />
          <StatItem label="Total Income" value={totalFees} color="#D32F2F" />
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Download Stats
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
